import { Box, Container, Typography } from '@mui/material'
import Navbar from '../../components/navbars/Navbar'

const APIErrorPage = ({
  fileUrl,
  msg,
  title,
  sscc,
  po,
}: {
  fileUrl: string
  msg: string
  title: string
  sscc: string
  po: string
}) => {
  return (
    <>
      <Navbar fileUrl={fileUrl} sscc={sscc} po={po} />
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 'calc(100% - 74px)',
        }}
        data-testid="error-page"
      >
        <Box>
          <Typography
            variant="h1"
            sx={{ fontSize: '25px', fontWeight: '500', color: '#145a4b', marginBottom: '12px' }}
            fontFamily={'Sanomat-Medium-Web'}
          >
            {title}
          </Typography>
          <div
            dangerouslySetInnerHTML={{ __html: msg }}
            style={{ fontSize: '16px', fontFamily: 'Sanomat-Medium-Web' }}
          />
        </Box>
      </Container>
    </>
  )
}

export default APIErrorPage
